import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a7d33ba6&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7d33ba6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a7d33ba6')) {
      api.createRecord('a7d33ba6', component.options)
    } else {
      api.reload('a7d33ba6', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=a7d33ba6&scoped=true", function () {
      api.rerender('a7d33ba6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/memberNew/activeCode/activeCodeGoods/index.vue"
export default component.exports